var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"screen-locker",class:{
    active: _vm.active,
    'screen-locker--has-background': _vm.hasBackground,
    'screen-locker--medium-background': _vm.hasMediumBackgroundLocker
  },style:(("--scoped-active-pointer-events: " + _vm.activePointerEvents + ";"))})}
var staticRenderFns = []

export { render, staticRenderFns }